const base = '/settings';

export const settingsRoutes = {
  base,
  admins: `${base}/admins`,
  users: `${base}/users`,
  userGroups: `${base}/users/groups`,
  application: `${base}/application`,
  versions: `${base}/versions`,
} as const;
